"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTargetOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M31 15h-3.07A12 12 0 0017 4.05V1h-2v3.05A12 12 0 004 15H1v2h3a12 12 0 0011 11v3h2v-3a12 12 0 0010.93-11H31zM17 26v-5h-2v5a10 10 0 01-9-9h5v-2H6a10 10 0 019-8.95v5h2v-5a10 10 0 019 9h-5v2h4.95A10 10 0 0117 26z" })));
}
exports.default = SvgTargetOutline;
//# sourceMappingURL=TargetOutline.js.map